// lib/gameCategory.js - Game category definitions with icons
import { 
  Trophy, 
  Zap, 
  Spade, 
  Fish, 
  Ticket 
} from 'lucide-react';

export const GAME_CATEGORIES = {
  Sports: {
    id: 'sports',
    name: 'Sports',
    icon: Trophy,
    color: 'bg-green-100 text-green-800',
    description: 'Sports betting and live sports events'
  },
  Slots: {
    id: 'slots',
    name: 'Slots',
    icon: Zap,
    color: 'bg-purple-100 text-purple-800',
    description: 'Slot machines and video slots'
  },
  Casino: {
    id: 'casino',
    name: 'Casino',
    icon: Spade,
    color: 'bg-red-100 text-red-800',
    description: 'Table games, blackjack, roulette, baccarat'
  },
  Fishing: {
    id: 'fishing',
    name: 'Fishing',
    icon: Fish,
    color: 'bg-blue-100 text-blue-800',
    description: 'Fishing games and arcade-style games'
  },
  Lottery: {
    id: 'lottery',
    name: 'Lottery',
    icon: Ticket,
    color: 'bg-yellow-100 text-yellow-800',
    description: 'Lottery games and number games'
  }
};

// Array of all game category names (for backward compatibility)
export const ALL_GAME_CATEGORIES = Object.keys(GAME_CATEGORIES);

// Get category config by name
export const getCategoryConfig = (categoryName) => {
  return GAME_CATEGORIES[categoryName] || null;
};

// Get category icon component
export const getCategoryIcon = (categoryName, size = 16) => {
  const config = getCategoryConfig(categoryName);
  if (!config) return null;
  
  const IconComponent = config.icon;
  return IconComponent;
};

// Get category color classes
export const getCategoryColor = (categoryName) => {
  const config = getCategoryConfig(categoryName);
  return config ? config.color : 'bg-gray-100 text-gray-800';
};

// Check if all categories are selected
export const isAllCategories = (selectedCategories) => {
  return selectedCategories.length === ALL_GAME_CATEGORIES.length &&
         ALL_GAME_CATEGORIES.every(cat => selectedCategories.includes(cat));
};

// Format categories for display
export const formatGameCategories = (categories) => {
  if (isAllCategories(categories)) {
    return 'All';
  }
  return categories;
};

// Get category badge component props
export const getCategoryBadgeProps = (categoryName) => {
  const config = getCategoryConfig(categoryName);
  if (!config) {
    return {
      color: 'bg-gray-100 text-gray-800',
      icon: null,
      name: categoryName
    };
  }
  
  return {
    color: config.color,
    icon: config.icon,
    name: config.name,
    description: config.description
  };
};

export default GAME_CATEGORIES;